import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, ShieldCheck, Loader2, MailCheck } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { api } from "../lib/api";

export const RecoveryEmailSection = ({ open, hasPassword }) => {
  const [info, setInfo] = useState(null);
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setPw("");
    api.getRecoveryEmail().then((d) => { setInfo(d); setEmail(d.recovery_email || ""); }).catch(() => {});
  }, [open]);
  const save = async () => {
    if (hasPassword && !pw) { toast.warning("أدخل كلمة المرور الحالية للتأكيد"); return; }
    setBusy(true);
    try {
      const d = await api.setRecoveryEmail(email.trim(), pw);
      setInfo(d); setPw("");
      toast.success("تم حفظ بريد الاستعادة");
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  if (!info) return null;
  return (
    <div className="space-y-3 rounded-xl border border-slate-200 p-3" data-testid="recovery-email-section">
      <p className="text-sm font-semibold text-slate-700 flex items-center gap-1.5"><MailCheck className="h-4 w-4 text-emerald-600" /> بريد استعادة كلمة المرور</p>
      {info.has_reset_email ? (
        <p className="flex items-center gap-1.5 rounded-lg bg-emerald-50 px-3 py-2 text-xs text-emerald-800" data-testid="recovery-email-ok">
          <ShieldCheck className="h-4 w-4 shrink-0" /> رموز الاستعادة وتنبيهات الأمان تصل إلى <b dir="ltr">{info.effective_masked}</b>
        </p>
      ) : (
        <p className="flex items-start gap-1.5 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs leading-relaxed text-amber-900" data-testid="recovery-email-warning">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
          <span><b>لا يوجد بريد مسجّل لحسابك.</b> إذا نسيت كلمة المرور لن تستطيع استعادتها بنفسك. أضف بريداً الآن.</span>
        </p>
      )}
      <div className="space-y-1.5">
        <Label htmlFor="rec-email">البريد الإلكتروني للاستعادة</Label>
        <Input id="rec-email" dir="ltr" type="email" placeholder="name@example.com" data-testid="recovery-email-input"
          value={email} onChange={(e) => setEmail(e.target.value)} />
      </div>
      {hasPassword && (
        <div className="space-y-1.5">
          <Label htmlFor="rec-pass">كلمة المرور الحالية (للتأكيد)</Label>
          <Input id="rec-pass" type="password" data-testid="recovery-email-password" value={pw} onChange={(e) => setPw(e.target.value)} />
        </div>
      )}
      <Button data-testid="recovery-email-save" disabled={busy} onClick={save} className="w-full gap-1.5 bg-emerald-600 hover:bg-emerald-700">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <MailCheck className="h-4 w-4" />} حفظ بريد الاستعادة
      </Button>
    </div>
  );
};
